module.exports = __webpack_public_path__ + "media/impact-2.ef341463.mp3";